import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { ActivityPreferencesList } from "../../../../SupplierPaymentPreferences"

export default function ActivityPaymentPreferencesPage() {
	return (
		<>
			<Helmet>
				<title>Activity Payment Preferences</title>
			</Helmet>
			<ForbidUnlessAuthorized
				permission={PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS}
			>
				<ActivityPreferencesList />
			</ForbidUnlessAuthorized>
		</>
	)
}
